import UseCaseTemplate, { type UseCaseContent } from '../../components/UseCaseTemplate';

const content: UseCaseContent = {
  slug: 'seeker-parking-guide',
  title: 'How to Find Parking in India — The Seeker\'s Guide | Parksy',
  description:
    "A step-by-step guide for seekers: how to find parking in Indian metros without paying brokerage, how to read price data, and how to use Parksy to its fullest.",
  canonicalPath: '/seeker-parking-guide',
  ogImage: 'https://parksy.rent/og/seeker-parking-guide.png',
  heroIntro:
    "Whether you're moving to a new city, changing offices, or just need parking for the next month, this is the playbook. Parksy is free and anonymous — the only thing you trade is your time to drop a pin and wait for a match email.",
  painPoints: [
    'Most parking searches default to Google Maps, which only shows official lots.',
    'Aggregators (Park+, NoBroker) take commission and push you to a paid plan.',
    'Word of mouth works — but only if you know someone in the area.',
    'Asking building RWAs for help often leads nowhere.',
  ],
  solutions: [
    { title: 'Drop a seeker pin', body: "Click the map at the exact location you need parking. Set vehicle type, duration, budget, and required features. Save your pin for 30 days." },
    { title: 'Wait for the daily match', body: "Our matching engine runs every day. When a compatible listing is dropped within 3 km, you both get an email with each other's contact." },
    { title: 'Use price transparency data', body: "Before you commit, check the price data for the area — it's crowdsourced from real people paying for parking. No sales quotes, no broker padding." },
  ],
  citySpotlights: [
    { slug: 'mumbai', name: 'Mumbai', note: 'See Bandra+ Andheri rates' },
    { slug: 'delhi', name: 'Delhi', note: 'See Saket+ Gurgaon rates' },
    { slug: 'bangalore', name: 'Bangalore', note: 'See Koramangala+ Whitefield rates' },
    { slug: 'hyderabad', name: 'Hyderabad', note: 'See Gachibowli rates' },
    { slug: 'pune', name: 'Pune', note: 'See Hinjewadi rates' },
    { slug: 'chennai', name: 'Chennai', note: 'See OMR rates' },
  ],
  faqs: [
    { question: 'Is Parksy really free for seekers?', answer: "Yes. No signup, no subscription, no commission. We cover costs through non-intrusive ads." },
    { question: 'How long does it take to get a match?', answer: "Matching runs daily. If a compatible listing exists in your area, you'll get an email within 24 hours. If nothing exists, the engine keeps checking until your pin expires (30 days)." },
    { question: 'Can I drop multiple seeker pins?', answer: "Yes — for different locations, different vehicle types, or different budgets. The matching engine considers all of them independently." },
    { question: 'What if no one lists in my area?', answer: "Pin what you currently pay — even if you're not looking for a new spot. More data in your area means better matches for everyone (including future you)." },
    { question: 'Is my contact info safe?', answer: "Your email and phone are shared only with matched users — never shown on the map. IPs are hashed; we don't sell data to anyone." },
  ],
  primaryCta: { label: 'Drop a seeker pin on the map →', to: '/' },
  secondaryCta: { label: 'See FAQ', to: '/faq' },
  breadcrumbs: [
    { label: 'Home', to: '/' },
    { label: 'Seeker guide' },
  ],
};

export default function SeekerParkingGuide() {
  return <UseCaseTemplate content={content} />;
}

